exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".citazione[data-v-c9acafae] {\n  background-color: #f0f0f0;\n  font-weight: 600;\n  border-left: 3px solid;\n}\nbutton[data-v-c9acafae] {\n  align-items: baseline;\n}\n.form-group label[data-v-c9acafae] {\n  font-weight: 600;\n}\n.form-group input[data-v-c9acafae] {\n  border-radius: 0;\n}", ""]);

// exports
